import { INFO_TOOLTIP_CLASS_NAME } from './constants';

const init = (e?: HTMLElement | null): void => {
  if (e) {
    $(e).tooltip();
  } else {
    $(INFO_TOOLTIP_CLASS_NAME).tooltip();
  }
};

const destroy = (e?: HTMLElement | null): void => {
  if (e) {
    $(e).tooltip('dispose');
  } else {
    $(INFO_TOOLTIP_CLASS_NAME).tooltip('dispose');
  }
};

const reinit = (e?: HTMLElement | null): void => {
  destroy(e);
  init(e);
};

const show = (e?: HTMLElement | null): void => {
  if (e) {
    $(e).tooltip('show');
  } else {
    $(INFO_TOOLTIP_CLASS_NAME).tooltip('show');
  }
};

export default { init, destroy, reinit, show };
